import { store } from '@betacrew/jars-flux'
export const componentKey = "PREPAY";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setTransactions : (state, action) => {
            state.transactions = action.payload;
        },
        setSkip : (state, action) => {
            state.skip = action.payload;
        },
        setRowsPerPage : (state, action) => {
            state.rowsPerPage = action.payload;
        },
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setExportFile: (state, action) => {
            state.exportFile = action.payload;
        },
        setTotalTransactions: (state, action) => {
            state.totalTransactions = action.payload;
        },
        setBifurcatedPrepayAmount: (state, action) => {
            state.bifurcatedPrepayAmount = action.payload;
        },
    },
    initialReducerState: {
        transactions: [],
        exportFile: false,
        totalTransactions: 0,
        rowsPerPage: 10,
        skip: 0,
        loadingState: false,
        bifurcatedPrepayAmount: {
            memberPrepay: 0,
            adminPrepay: 0,
        },
    }
});
export const { setTransactions, setSkip, setRowsPerPage, setLoadingState, setExportFile, setTotalTransactions, setBifurcatedPrepayAmount } = actions;